// Shared range control. Reads/writes the `?range=` URL param so reloads
// preserve state and the value is sharable.
import { useSearchParams } from 'react-router-dom';
import { RANGE_OPTIONS, type RangeKey } from './types';

const FALLBACK_RANGE: RangeKey = '12mo';

export function useRangeKey(defaultRange: RangeKey = FALLBACK_RANGE): RangeKey {
  const [params] = useSearchParams();
  const raw = params.get('range') || defaultRange;
  return (RANGE_OPTIONS.some((o) => o.value === raw) ? raw : defaultRange) as RangeKey;
}

interface Props {
  defaultRange?: RangeKey;
}

export default function TimeRangeControl({ defaultRange = FALLBACK_RANGE }: Props = {}) {
  const [params, setParams] = useSearchParams();
  const current = useRangeKey(defaultRange);

  const setRange = (value: RangeKey) => {
    const next = new URLSearchParams(params);
    next.set('range', value);
    setParams(next, { replace: true });
  };

  return (
    <div className="trends-range-control" role="tablist" aria-label="Time range">
      {RANGE_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={current === opt.value}
          className={`trends-range-btn${current === opt.value ? ' active' : ''}`}
          onClick={() => setRange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
